// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aC3diH {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 200px;
  padding: var(--spacing-4, 32px);
}

.MBsxQL {
  position: absolute;
  right: 24px;
  top: 64px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}

.JzHIxV {
  margin: 0;
  min-width: auto;
  width: 100%;
}

.rH446W {
  justify-content: center;
  display: flex;
  min-height: 100%;
}

.hjhQIF {
  display: flex;
  font-family: var(--font-family-base);
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  max-width: 733px;
}

.b05Zm2 {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  min-height: 0;
  gap: var(--spacing-3);
}

.EySwul {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  gap: var(--spacing-1-5);
  padding: var(--spacing-3);
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/RechargePaymentBankSlipPage/RechargePaymentBankSlipPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 200px;\n  padding: var(--spacing-4, 32px);\n}\n\n.alertMessage {\n  position: absolute;\n  right: 24px;\n  top: 64px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n\n.bankSlipAnnotation {\n  margin: 0;\n  min-width: auto;\n  width: 100%;\n}\n\n.container {\n  justify-content: center;\n  display: flex;\n  min-height: 100%;\n}\n\n.content {\n  display: flex;\n  font-family: var(--font-family-base);\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  max-width: 733px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  min-height: 0;\n  gap: var(--spacing-3);\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  align-self: stretch;\n  gap: var(--spacing-1-5);\n  padding: var(--spacing-3);\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `aC3diH`,
	"alertMessage": `MBsxQL`,
	"bankSlipAnnotation": `JzHIxV`,
	"container": `rH446W`,
	"content": `hjhQIF`,
	"body": `b05Zm2`,
	"footer": `EySwul`
};
module.exports = ___CSS_LOADER_EXPORT___;
